export default __webpack_public_path__ + "static/media/ic_note.120b2a6d.svg";